import useDoctorNotifications from "../../hooks/useDoctorNotifications";

import "./doctor-notifications.css";

/** Счётчик непрочитанных для пункта меню */
export default function NotificationBadge({ className = "" }) {
    const { enabled, unreadTotal } = useDoctorNotifications();

    if (!enabled || unreadTotal <= 0) return null;

    const display = unreadTotal > 99 ? "99+" : String(unreadTotal);

    return (
        <span
            className={`doctor-notification-nav-badge ${className}`}
            aria-label={`Непрочитанных уведомлений: ${unreadTotal}`}
        >
            {display}
        </span>
    );
}
